/** Read-only offline cache of the current set (sheet PDFs + sheet detail JSON). Phase 2 adds
 *  offline markups + sync; this stays the storage they will queue into. */
const CACHE = "drawings-offline-v1";
const supported = () => typeof window !== "undefined" && "caches" in window;

const pdfKey = (sheetId) => `/offline/sheet/${sheetId}/file`;
const jsonKey = (sheetId) => `/offline/sheet/${sheetId}/detail`;
const indexKey = (projectId) => `/offline/project/${projectId}/index`;

export async function cacheSheet(sheetId, pdfBytes, detail) {
  if (!supported()) return false;
  const c = await caches.open(CACHE);
  await c.put(pdfKey(sheetId), new Response(pdfBytes, { headers: { "Content-Type": "application/pdf" } }));
  await c.put(jsonKey(sheetId), new Response(JSON.stringify({ ...detail, cached_at: new Date().toISOString() }),
    { headers: { "Content-Type": "application/json" } }));
  return true;
}

export async function cachedSheet(sheetId) {
  if (!supported()) return null;
  const c = await caches.open(CACHE);
  const [pdf, json] = await Promise.all([c.match(pdfKey(sheetId)), c.match(jsonKey(sheetId))]);
  if (!pdf || !json) return null;
  return { pdf: await pdf.arrayBuffer(), detail: await json.json() };
}

export async function cacheIndex(projectId, index) {
  if (!supported()) return;
  const c = await caches.open(CACHE);
  await c.put(indexKey(projectId), new Response(JSON.stringify(index),
    { headers: { "Content-Type": "application/json" } }));
}

export async function cachedIndex(projectId) {
  if (!supported()) return null;
  const c = await caches.open(CACHE);
  const r = await c.match(indexKey(projectId));
  return r ? r.json() : null;
}

export async function cachedSheetIds() {
  if (!supported()) return new Set();
  const c = await caches.open(CACHE);
  const keys = await c.keys();
  return new Set(keys.map((k) => new URL(k.url).pathname).filter((p) => p.endsWith("/detail"))
    .map((p) => p.split("/")[3]));
}

export async function clearOffline() {
  if (supported()) await caches.delete(CACHE);
}
